import { defineComponent as _defineComponent } from 'vue'
import Button from '~/src_common/components/parts/button/Button.vue';

// isDesktop はグローバル mixin（src/main.js=true, src_sp/main.js=false）を
// テンプレートで直接参照する（AppDownloadBanner.vue・CompleteContactCta.vue と同様のパターン）。
// 箱の作り（角丸・白地・padding・見出し）は AppDownloadBanner に合わせている。

export default /*#__PURE__*/_defineComponent({
  __name: 'CompleteMypageSection',
  props: {
  // password: 受付番号のあるお申込みのみ表示する条件として使用。
  password: { type: String, default: '' },
  loading: { type: Boolean, default: false },
},
  emits: ['navigate-to-mypage'],
  setup(__props) {





return { __sfc: true,Button }
}

})